import { Share2, Link2, Check } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { shareText } from "@/lib/activity";
import { tanggalPanjang } from "@/lib/format";

export const ShareButtons = ({ activity, dark = false }) => {
  const [copied, setCopied] = useState(false);
  const url = `${window.location.origin}/kegiatan/${activity.id}`;
  const text = shareText(activity, url, tanggalPanjang(activity.date));
  const waHref = `https://wa.me/?text=${encodeURIComponent(text)}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Link kegiatan disalin");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Gagal menyalin link");
    }
  };

  return (
    <div className="flex flex-wrap gap-2" data-testid="share-buttons">
      <a href={waHref} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-full bg-[#25D366] text-white text-sm font-semibold px-4 py-2 hover:bg-[#1fb857] transition-colors" data-testid="share-whatsapp-btn">
        <Share2 size={15} /> Bagikan ke WhatsApp
      </a>
      <Button type="button" variant="outline" onClick={copy} className={`rounded-full ${dark ? "border-white/30 text-white hover:bg-white/10 bg-transparent" : ""}`} data-testid="share-copy-btn">
        {copied ? <Check size={15} className="mr-1" /> : <Link2 size={15} className="mr-1" />} {copied ? "Tersalin" : "Salin Link"}
      </Button>
    </div>
  );
};
